(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORAGE_KEY = 'cc_recently_viewed';
  var DAY_MS = 86400000;

  function readList(expiryDays) {
    var raw;
    try {
      raw = window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return [];
    }
    var list;
    try {
      list = JSON.parse(raw);
    } catch (e) {
      list = null;
    }
    if (!Array.isArray(list)) return [];
    var cutoff = Date.now() - (expiryDays * DAY_MS);
    return list.filter(function (item) {
      return item && typeof item.id === 'number' && typeof item.t === 'number' && item.t > cutoff;
    });
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // Private browsing or storage full - nothing to do.
    }
  }

  function remember(currentId, expiryDays, storageLimit) {
    if (!currentId) return;
    var list = readList(expiryDays).filter(function (item) {
      return item.id !== currentId;
    });
    list.unshift({ id: currentId, t: Date.now() });
    writeList(list.slice(0, storageLimit));
  }

  function populate(container, html, orderedIds, limit) {
    var temp = document.createElement('div');
    temp.innerHTML = html;

    var blocks = {};
    Array.prototype.forEach.call(temp.querySelectorAll('product-block[data-product-id]'), function (block) {
      blocks[block.getAttribute('data-product-id')] = block;
    });

    var grid = container.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    var added = 0;
    orderedIds.forEach(function (id) {
      if (added >= limit) return;
      var block = blocks[String(id)];
      if (!block) return;
      grid.appendChild(block);
      added++;
    });

    if (added > 0) {
      container.querySelector('[data-recently-viewed-inner]').hidden = false;
    }
  }

  function init(container) {
    if (!container || container.getAttribute('data-rv-init') === 'true') return;
    container.setAttribute('data-rv-init', 'true');

    var expiryDays = parseInt(container.getAttribute('data-expiry-days'), 10) || 30;
    var storageLimit = parseInt(container.getAttribute('data-storage-limit'), 10) || 16;
    var limit = parseInt(container.getAttribute('data-limit'), 10) || 8;
    var currentId = parseInt(container.getAttribute('data-current-product-id'), 10) || 0;

    // Read the list BEFORE recording the current product, so it is not shown to itself.
    var orderedIds = readList(expiryDays)
      .map(function (item) { return item.id; })
      .filter(function (id) { return id !== currentId; })
      .slice(0, storageLimit);

    remember(currentId, expiryDays, storageLimit);

    if (!orderedIds.length) return;

    var query = orderedIds.map(function (id) { return 'id:' + id; }).join(' OR ');
    var url = container.getAttribute('data-search-url') +
      '?section_id=' + encodeURIComponent(container.getAttribute('data-section-type')) +
      '&type=product' +
      '&q=' + encodeURIComponent(query);

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recently viewed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        populate(container, html, orderedIds, limit);
      })
      .catch(function () {
        // Fail silently - the section simply stays hidden.
      });
  }

  function initAll(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('.recently-viewed-products'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function(container) {
  if (!container || container.getAttribute('data-rp-loaded') === 'true') { return; }
  container.setAttribute('data-rp-loaded', 'true');

  var request = new XMLHttpRequest();
  request.open("GET", container.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var temp = document.createElement("div");
      temp.innerHTML = request.response;
      var fetched = temp.querySelector(".related-products");
      if (fetched) {
        container.innerHTML = fetched.innerHTML;
      }
    }
  };
  request.send();
};

var loadAllProductRecommendations = function(scope) {
  var root = scope || document;
  Array.prototype.forEach.call(root.querySelectorAll(".related-products"), loadProductRecommendationsIntoSection);
};

document.addEventListener("shopify:section:load", function(event) {
  loadAllProductRecommendations(event.target);
});

loadAllProductRecommendations();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["same-vendor-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function populate(container, html, limit, currentId) {
    var temp = document.createElement('div');
    temp.innerHTML = html;

    var grid = container.querySelector('[data-same-vendor-grid]');
    if (!grid) return;

    var added = 0;
    Array.prototype.forEach.call(temp.querySelectorAll('product-block[data-product-id]'), function (block) {
      if (added >= limit) return;
      if (block.getAttribute('data-product-id') === String(currentId)) return;
      grid.appendChild(block);
      added++;
    });

    if (added > 0) {
      container.querySelector('[data-same-vendor-inner]').hidden = false;
    }
  }

  function init(container) {
    if (!container || container.getAttribute('data-sv-init') === 'true') return;
    container.setAttribute('data-sv-init', 'true');

    // The metafield already filled the track in Liquid - nothing to fetch.
    if (container.getAttribute('data-has-content') === 'true') return;

    var vendor = container.getAttribute('data-vendor');
    if (!vendor) return;

    var limit = parseInt(container.getAttribute('data-limit'), 10) || 8;
    var currentId = parseInt(container.getAttribute('data-current-product-id'), 10) || 0;

    var url = container.getAttribute('data-vendors-url') +
      '?q=' + encodeURIComponent(vendor) +
      '&sort_by=created-descending' +
      '&section_id=' + encodeURIComponent(container.getAttribute('data-section-type'));

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Same vendor: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        populate(container, html, limit, currentId);
      })
      .catch(function () {
        // Fail silently - the section simply stays hidden.
      });
  }

  function initAll(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('.same-vendor-products'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
